import { jsx as _jsx } from "react/jsx-runtime";
import { callAll, noop } from '@showroomjs/core';
import * as React from 'react';
import { copyText } from '../lib/copy';
import { useTransientState } from '../lib/use-transient-state';
import { styled } from '../stitches.config';
import { buttonBase } from './base';
export const CopyButton = React.forwardRef(function CopyButton({ getTextToCopy, label = 'Copy', successLabel = 'Copied!', className, onCopy = noop, onClick, ...btnProps }, forwardedRef) {
    const [copied, setCopied] = useTransientState(false);
    return (_jsx(Button, { type: "button", onClick: callAll(onClick, () => copyText(getTextToCopy()).then(() => {
            setCopied(true);
            onCopy();
        })), className: className, ...btnProps, ref: forwardedRef, children: copied ? successLabel : label }));
});
const Button = styled('button', {
    ...buttonBase,
    fontSize: '$sm',
    lineHeight: '$sm',
});
//# sourceMappingURL=copy-button.js.map